import React from "react";
import styled from "styled-components";
import { Container, Row, Col } from "react-bootstrap";
import { FaInstagram, FaSpotify, FaGithub, FaLinkedin } from "react-icons/fa";

import styles from "./MiniCenteredFooter.module.css";

const AuthorTitle = styled.h1`
  font-size: 1rem;
  color: #636363;
  text-transform: uppercase;
`;

const AuthorLinkedIn = styled.a`
  color: #636363;
  text-decoration: none;
`;

const MiniCenteredFooter = () => {
  const icons = [
    {
      icon: (
        <FaGithub
          size={35}
          className={styles.icon}
          onClick={() => {
            window.open("https://github.com/Ducksss", "_blank");
          }}
        />
      ),
    },
    {
      icon: (
        <FaLinkedin
          size={35}
          className={styles.icon}
          onClick={() => {
            window.open(
              "https://www.linkedin.com/in/chai-pin-zheng-5610921aa/",
              "_blank"
            );
          }}
        />
      ),
    },
    {
      icon: (
        <FaInstagram
          size={35}
          className={styles.icon}
          onClick={() => {
            window.open("https://www.instagram.com/pin.zhengg/", "_blank");
          }}
        />
      ),
    },
    {
      icon: (
        <FaSpotify
          size={35}
          className={styles.icon}
          onClick={() => {
            window.open(
              "https://open.spotify.com/user/21j5swdgjljpuoztk7ryibixq",
              "_blank"
            );
          }}
        />
      ),
    },
  ];

  return (
    <div className="bg-black mt-5 pb-0 pb-md-3">
      <Container className="pt-5 pb-4">
        <div className="d-flex justify-content-center">
          {icons.map((item) => {
            return <div className="px-4">{item.icon}</div>;
          })}
        </div>
        <div className="d-flex justify-content-center pt-4">
          <AuthorTitle>
            Built by{" "}
            <AuthorLinkedIn href="https://www.linkedin.com/in/chai-pin-zheng-5610921aa/">
              Chai Pin Zheng
            </AuthorLinkedIn>
          </AuthorTitle>
        </div>
      </Container>
    </div>
  );
};

export default MiniCenteredFooter;
